module.exports = __webpack_public_path__ + "img/Logo(1).4f39be29.png";